/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/dialog/style/css';
import { ElCheckbox as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/checkbox/style/css';
import { ElButton as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/button/style/css';
import { ElPagination as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/pagination/style/css';
import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  "class": "block report-list journal-list"
};
var _hoisted_2 = {
  "class": "journal-item"
};
var _hoisted_3 = {
  "class": "media"
};
var _hoisted_4 = {
  "class": "media-left"
};
var _hoisted_5 = {
  "class": "img-box"
};
var _hoisted_6 = {
  "class": "img"
};
var _hoisted_7 = ["src", "alt"];
var _hoisted_8 = {
  "class": "media-body"
};
var _hoisted_9 = ["textContent"];
var _hoisted_10 = ["innerHTML"];
var _hoisted_11 = {
  "class": "paging"
};
var _hoisted_12 = {
  "class": "right-content"
};
import { newsListApi } from '@/api/activi';
import { saveInformationApi } from '@/api/footer';
export default /*@__PURE__*/_defineComponent({
  __name: 'Study',
  setup: function setup(__props) {
    var newsData = ref([{
      id: '',
      name: '',
      context: '',
      createTime: '',
      image: ''
    }]);
    var currentPage = ref(1);
    var newParam = ref({
      pageNum: currentPage.value,
      pageSize: 10,
      type: 1,
      hotspot: ''
    });
    var dialogVisible = ref(false);
    var formData = ref({
      email: ''
    });
    var checked = ref(false);
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            getNewsList();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var total = ref(0);
    function getNewsList() {
      return _getNewsList.apply(this, arguments);
    }
    function _getNewsList() {
      _getNewsList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, _res$data$records, _res$data, _res$data$total, _res$data2, _res$data$current, _res$data3;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return newsListApi(newParam.value);
            case 2:
              res = _context2.sent;
              console.log(res, 'res');
              if (res.code == 200) {
                newsData.value = (_res$data$records = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.records) !== null && _res$data$records !== void 0 ? _res$data$records : [];
                total.value = (_res$data$total = (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.total) !== null && _res$data$total !== void 0 ? _res$data$total : 0;
                currentPage.value = (_res$data$current = (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.current) !== null && _res$data$current !== void 0 ? _res$data$current : 1;
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _getNewsList.apply(this, arguments);
    }
    function handelCurrentChange(pageNum) {
      newParam.value.pageNum = pageNum;
      getNewsList();
    }
    function clickItem() {
      dialogVisible.value = true;
    }
    function submit() {
      if (formData.value.email === '') {
        ElMessage.error('请输入电子邮箱');
      } else {
        checked.value = true;
        saveInformationApi(formData.value).then(function (res) {
          dialogVisible.value = false;
          if (res.code === 200) {
            ElMessage.success(res.msg);
          } else {
            ElMessage.error(res.msg);
          }
        });
      }
    }
    return function (_ctx, _cache) {
      var _component_el_pagination = __unplugin_components_0;
      var _component_el_button = __unplugin_components_1;
      var _component_el_checkbox = __unplugin_components_2;
      var _component_el_dialog = __unplugin_components_3;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(newsData), function (item) {
        return _openBlock(), _createElementBlock("div", {
          "class": "container",
          key: item.id
        }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
          src: item.image,
          alt: item.name
        }, null, 8, _hoisted_7)])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
          "class": "journal-title",
          textContent: _toDisplayString(item.name)
        }, null, 8, _hoisted_9), _createElementVNode("div", {
          "class": "journal-info",
          innerHTML: item.context
        }, null, 8, _hoisted_10), _createElementVNode("div", {
          "class": "journal-more"
        }, [_createElementVNode("p", {
          "class": "more-btn btn-small",
          onClick: clickItem
        }, "申请报告")])])])])]);
      }), 128))]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_pagination, {
        "current-page": _unref(currentPage),
        "onUpdate:currentPage": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(currentPage) ? currentPage.value = $event : null;
        }),
        onCurrentChange: handelCurrentChange,
        background: "",
        layout: "prev, pager, next",
        total: _unref(total),
        "class": "mt-4"
      }, null, 8, ["current-page", "total"])]), _createVNode(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return _isRef(dialogVisible) ? dialogVisible.value = $event : null;
        }),
        title: "",
        width: "45%",
        "close-on-click-modal": false,
        center: ""
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", _hoisted_12, [_createElementVNode("ul", null, [_cache[6] || (_cache[6] = _createElementVNode("li", null, "想申请获取研究报告？", -1)), _cache[7] || (_cache[7] = _createElementVNode("li", {
            "class": "aas"
          }, "请通过下方栏目提交邮箱，将为您发送相关研究成果", -1)), _cache[8] || (_cache[8] = _createElementVNode("li", {
            "class": "aa"
          }, "格式为：邮箱地址+姓名+报告标题全称", -1)), _cache[9] || (_cache[9] = _createElementVNode("li", {
            "class": "aa"
          }, "(zhangsan@126.com+张三+中国资产管理趋势洞察)", -1)), _createElementVNode("li", null, [_withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return _unref(formData).email = $event;
            }),
            placeholder: "输入电子邮件信息"
          }, null, 512), [[_vModelText, _unref(formData).email]]), _createVNode(_component_el_button, {
            onClick: submit
          }, {
            "default": _withCtx(function () {
              return _cache[4] || (_cache[4] = [_createTextVNode("提交")]);
            }),
            _: 1
          })]), _createElementVNode("li", null, [_createVNode(_component_el_checkbox, {
            modelValue: _unref(checked),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return _isRef(checked) ? checked.value = $event : null;
            }),
            size: "large"
          }, null, 8, ["modelValue"]), _cache[5] || (_cache[5] = _createTextVNode("我愿意接收来自IIFA的邮件，并遵守IIFA相关服务协议和隐私政策 "))])])])];
        }),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
});